$(document).ready(function(){

	var $tab = $('a#comment-tab', $viewport),
		$container = $('div#comment-tab-container', $viewport);

	$container.hide();

	$tab.on('click', function(e){
		e.preventDefault();

		$container.toggle();
	});

});
